import { createFileRoute } from "@tanstack/react-router";
import AnswersIndex from "@/pages/AnswersIndex";
import { answersIndexHead } from "@/lib/answersSeo";
import { SITE_URL } from "@/lib/site-url";

export const Route = createFileRoute("/en/answers/")({
  head: () => {
    const h = answersIndexHead("en");
    return {
      meta: [
        { title: h.title },
        { name: "description", content: h.description },
        { property: "og:title", content: h.title },
        { property: "og:description", content: h.description },
        { property: "og:url", content: `${SITE_URL}/en/answers` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: h.title },
        { name: "twitter:description", content: h.description },
      ],
      links: [
        { rel: "canonical", href: `${SITE_URL}/en/answers` },
        { rel: "alternate", hrefLang: "es", href: `${SITE_URL}/consultas-resueltas` },
        { rel: "alternate", hrefLang: "en", href: `${SITE_URL}/en/answers` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE_URL}/consultas-resueltas` },
      ],
    };
  },
  component: () => <AnswersIndex routeLang="en" />,
});
